<template>
  <NgBasicView
    v-bind="$attrs"
    class="pb-basic-view"
    unstyled
  >
    <template v-if="showHeader || hasHeaderSlot" #header>
      <slot name="header">
        <div class="pb-basic-view-header">
          <Asset src="Images/Logos/SVG/Nicolaudie-profile-builder.svg" />
        </div>
      </slot>
    </template>
    <template #default>
      <slot />
    </template>
    <template v-if="hasFooterSlot" #footer>
      <slot name="footer" />
    </template>
  </NgBasicView>
</template>

<script setup>
import NgBasicView from '@nicolaudie-group/ng-ui-kit/components/NgBasicView/NgBasicView.vue'
import Asset from '@nicolaudie-group/ng-ui-kit/components/Asset/Asset.vue'
import useHasContent from '@nicolaudie-group/ng-ui-kit/composables/useHasContent'

defineProps({
  showHeader: { type: Boolean, default: false },
})

const hasHeaderSlot = useHasContent('header')
const hasFooterSlot = useHasContent('footer')
</script>

<style lang="scss">
@use 'sass:math';
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';

.pb-basic-view {
  padding: 0;
  padding-top: 50px;

  > .ng-basic-view-content {
    @include flexbox.flexbox();
    @include flexbox.flex-direction(column);
    padding-bottom: 50px;
    min-height: 100%;

    > .ng-basic-view-header {
      padding-top: 0;
      margin-bottom: 50px;
    }

    > .ng-basic-view-body {
      margin-top: 0;
    }

    > .ng-basic-view-footer {
      padding: 0;
      padding-top: 50px;
      margin-top: auto;
    }
  }

  .pb-basic-view-header {
    text-align: center;
  }
}
</style>
